export const manifestQuote = [
  {
    byline: '– Jonny Lindén, grundare.',
    text: 'Att ha en egen bil ska göra dig fri att ta dig vart du vill, när du vill och hur du vill. Framför allt ska det vara enkelt och tryggt för dig att byta ditt fordon när du vill, utan problem. Och därför finns Blipp!',
  },
];

export const releaseQuotes = [
  {
    byline: '- Martin Andersson, Constant Mark AB',
    text: 'Tack vare Release så sänkte jag min månadskostnad med 2 900 kr / mån och kunde samtidigt leasa vidare bilen. Besparing på över 30 000 kr per år tackar man inte nej till i dessa tider. Tack för hjälpen Filip på Blipp',
  },
];

export const carLoanQuotes = [
  {
    byline: '- Andreas',
    text: 'Första gången jag använde Blipp och jag måste säga att bilaffären blev väldigt enkel och trygg. Tidigare har jag upplevt att det kan vara jobbigt och otryggt att göra affärer med stora summor på blocket men tack vare Blipp var det inte svårare än att handla på en vanlig affär.',
  },
];
